export class RoutingFeatures
{
    static LOGIN = "login";
    static CREATE_ACCOUNT = "signup";
    static CREATE_ACCOUNT_OTP = "signup-otp";
    static FORGOT_PASSWORD = "forgot-password";
    static FORGOT_PASSWORD_OTP = "forgot-Password-otp";
    static CREATE_ACCOUNT_OTP_MESSAGE = "signup-msg";
    static HOME = "home";
    static MENU_CATEGROIES = "categories";
    static FEATURED_CATEGROIES = "feature-categories";
    static SEARCH = "search";
    static SEARCH_LIST = "search-list";
    static ARTIST_SEARCH = "artist-search";
    static BANNER_SEARCH = "banner-search";
    static PROFILE = "profile";
    static WISHLIST = "wishlist";
    static MYTUNES = "mytunes";
    static PLAYLIST = "playlist";
    static FAQ = "faq";
    static DO_IT_YOURSELF = "doityourself";
    static TRANSACTION_HISTORY = "transaction-history";
    static CALLER_GROUP = "caller-group";
    static BLACKLIST = "blacklist";
    static DEFAULT = "default";
    static LOGOUT = "logout";
    static NAME_TUNES = "name-tunes";
    static LANDING_PAGE = "landingpage";
    static ERROR = "error";
    static FORBIDDEN = "forbidden";
    static NOT_FOUND = "notfound";
    static TERMS_AND_CONDITION = "terms-and-condition";
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/navigation/routingfeature.ts